import React from "react";
import {
  Box,
  Button,
  Typography,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import theme from "../../../constants/theme";

// Standalone full-screen error page styled after the legacy dog pages.
// Self-contained (own theme providers) so it can render at any route, with
// or without a surrounding layout.
export default function ErrorPage({ title, errorCode, infoText }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            minHeight: "100vh",
            px: 2,
            backgroundColor: "#FFFFFF",
          }}
        >
          <Box
            component="img"
            src="/Dog-02.svg"
            alt=""
            width={230}
            height={159}
          />
          <Typography
            variant="h5"
            sx={{ color: "#605D66", fontWeight: 400, mt: 6 }}
          >
            {title}
          </Typography>
          <Typography
            sx={{ color: "#B3261E", fontSize: 14, fontWeight: "bold", mt: 4 }}
          >
            {errorCode}
          </Typography>
          <Typography sx={{ color: "#605D66", fontSize: 14, mt: 4 }}>
            {infoText}
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              // The stored slug is how the user got here: post-login routing
              // replays it, so leaving it in place turns this button into a
              // loop back to the same dead page.
              try {
                window.localStorage.removeItem("current_school_slug");
              } catch (e) {
                /* blocked storage: nothing stored to drop */
              }
              window.location.assign("/");
            }}
            sx={{ mt: 5, backgroundColor: "#2196F3" }}
          >
            Return to AE-Connect
          </Button>
        </Box>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
